<template>
    <div class="review-container" style="margin-top: 10px;margin-left: 30px;">
        <el-tabs v-model="activeTab">
            <el-tab-pane label="AI智能合规评估" name="review">
                <!-- 第一部分：主体信息 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>企业信息</span>
                    </div>
                    <el-descriptions :column="2" border>
                        <el-descriptions-item label="主体名称">{{ formData.companyName }}</el-descriptions-item>
                        <el-descriptions-item label="统一社会信用码">{{ formData.socialCreditCode }}</el-descriptions-item>

                    </el-descriptions>
                </el-card>

                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>联系人信息</span>
                    </div>
                    <el-descriptions :column="2" border>

                        <el-descriptions-item label="联系人">{{ formData.contactsName }}</el-descriptions-item>
                        <el-descriptions-item label="手机号">{{ formData.contactsPhone }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>


                <!-- 第二部分：基本信息 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="数据资产名称" class="custom-label">{{ formData.assetName
                            }}</el-descriptions-item>
                        <el-descriptions-item label="数据来源">{{ formData.dataSource }}</el-descriptions-item>
                        <el-descriptions-item label="所属行业">{{ formData.industry }}</el-descriptions-item>
                        <el-descriptions-item label="数据类型">{{ formData.dataType }}</el-descriptions-item>
                        <el-descriptions-item label="数据覆盖地域">{{ formData.region }}</el-descriptions-item>
                        <el-descriptions-item label="应用场景描述">{{ formData.scenario }}</el-descriptions-item>
                        <el-descriptions-item label="数据资产简介">{{ formData.description }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 第三部分：数据属性 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>数据属性</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="数据结构">{{ formData.dataScaleType }}</el-descriptions-item>
                        <el-descriptions-item
                            v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '结构化数据'"
                            label="存储空间">{{ formData.storageSize +' '+ formData.storageUnit }} </el-descriptions-item>
                        <el-descriptions-item
                            v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '结构化数据'"
                            label="数据规模">{{ formData.tableCount + "个数据表，" + formData.fieldCount + "个字段，" 
                               + formData.recordCount + "条数据"  }}</el-descriptions-item>
                        <el-descriptions-item
                            v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '非结构化数据'"
                            label="文件数量">
                            {{ formData.fileCount }}
                        </el-descriptions-item>
                        <el-descriptions-item label="数据期间">{{ formatDateTime(formData.dataStartTime)+" 至 "
                            + formatDateTime(formData.dataEndTime) }}</el-descriptions-item>
                        <el-descriptions-item label="更新周期">{{ formData.updateCycle }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 第四部分：产权信息 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>产权信息</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="权利类型">{{ formData.rightsType }}</el-descriptions-item>
                        <el-descriptions-item label="产权期限">{{ formatDateTime(formData.assetsStartTime)+" 至 "
                            + formatDateTime(formData.assetsEndTime) }}</el-descriptions-item>
                        <el-descriptions-item label="使用限制">{{ formData.usageLimit }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 第五部分：证明材料 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>证明材料</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="数据资产查验报告">
                            <el-link type="primary" v-if="formData.reportFile" @click="downloadFile(formData.reportFile)">{{ formData.reportFile }}</el-link>
                            <span v-else>无</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="数据资产查验详情表">
                            <el-link type="primary" v-if="formData.verificationFile" @click="downloadFile(formData.verificationFile)">{{ formData.verificationFile }}</el-link>
                            <span v-else>无</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="数据资产登记承诺书">
                            <el-link type="primary" v-if="formData.commitmentFile" @click="downloadFile(formData.commitmentFile)">{{ formData.commitmentFile }}</el-link>
                            <span v-else>无</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="其他材料">
                            <el-link type="primary" v-if="formData.otherFile" @click="downloadFile(formData.otherFile)">{{ formData.otherFile }}</el-link>
                            <span v-else>无</span>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-card>

               
                <!-- AI智能审核报告部分 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>AI智能审核报告</span>
                    </div>
                    <el-input type="textarea" readonly :rows="4" v-model="formData.aiReviewOpinion" placeholder="请输入审核意见"
                        class="review-comment-input">
                    </el-input>
                </el-card>

                <!-- 补充信息部分 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>补充意见</span>
                    </div>
                    <el-input type="textarea" :rows="4" v-model="formData.supComm" placeholder="请输入补充意见（非必填）"
                        class="review-comment-input">
                    </el-input>
                </el-card>


                <!-- 操作按钮部分 -->
                <div class="action-buttons">
                    <el-button v-if="!formData.isReview" type="warning" @click="handleApprove">
                        提交智能审核
                    </el-button>
                    <el-button v-if="formData.isReview" type="primary" @click="handleApprove">
                        再次审核
                    </el-button>
                    <el-button v-if="formData.isReview" type="success" @click="GetLegalOpinion">
                        生成法律意见书
                    </el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: "ReviewPage",
    data() {
        return {
            activeTab: 'review',
            registrationId: '',
            formData: {
                // 主体信息字段
                companyName: '',
                userId: '',
                socialCreditCode: '',
                contactsName: '',
                contactsPhone: '',

                // 资产信息字段
                platformName: '',
                assetName: '',
                dataSource: '',
                industry: '',
                dataType: '',
                region: '',
                dataScaleType: '',
                storageUnit: '',
                contactName: '',
                fieldCount: '',
                creator: '',
                updater: '',
                dataPeriod: '',
                updateCycle: '',
                rightsType: '',
                rightsPeriod: '',
                usageLimit: '',
                scenario: '',
                description: '',

                // 证明材料字段
                reportFile: '',
                verificationFile: '',
                commitmentFile: '',
                otherFile: '',
                aiReviewOpinion: '',
                supComm:'',
                isReview:''
            },
        }
    },
    created() {
        this.registrationId = this.$route.query.registrationId;
        this.loadData();
    },
    methods: {
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-'
            
            const date = new Date(dateTime)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            
            return `${year}-${month}-${day}`
        },
        async loadData() {
            try {
                const response = await this.getRequest('/web/dataAssets/approve/getIntelligentDetailByRegistrationId?registrationId=' + this.registrationId,);

                if (response.status === 200) {
                    console.log(response);
                    this.formData = response.data;
                }


            } catch (error) {
                console.error('加载数据失败:', error);
                this.$message.error('数据加载失败，请稍后重试');
            }
        },

        
        handleApprove() {
            
            this.$confirm('确认审核通过该数据资产?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                // 提取文件字段
                // const fileData = {
                //     reportFile: this.formData.reportFile,
                //     verificationFile: this.formData.verificationFile,
                //     commitmentFile: this.formData.commitmentFile,
                //     otherFile: this.formData.otherFile
                // };

                // // 创建不包含文件字段的formData副本
                // const { reportFile, verificationFile, commitmentFile, otherFile, ...basicData } = this.formData;

                // // 构造请求数据
                // const requestData = {
                //     basicDataInformation: basicData,
                //     fileData: fileData,
                // };
                // console.log(requestData);
                this.$axios.post('/web/dataAssets/approve/pass_ai', this.formData).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('审核通过成功');
                        this.AIReviewComment = resp.data.msg;
                    }
                }); 
            });
        },
        GetLegalOpinion(){
            this.$axios.post('/web/dataAssets/approve/ai_getLegalOpinion', this.formData).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('AI法律意见书生成成功');
                        this.AIReviewComment = resp.data.msg;
                    }
                });
        },
       
        async downloadFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/file/download/' + filename,
                    params: { 
                        registrationId: this.registrationId,
                        userId: this.formData.userId 
                    },
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        viewCertificateDetail() {
            if (this.formData.certificateFile) {
                this.$router.push({
                    path: '/company/certificate-detail',
                    query: {
                        registrationId: this.registrationId,
                        certificateFile: this.formData.certificateFile
                    }
                });
            } else {
                this.$message.warning('证书文件不存在');
            }
        }
    }
}
</script>

<style scoped>
.review-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 40px);
}

.detail-card {
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: visible;
}

.detail-card>>>.el-card__header {
    background-color: #e2e4e7;
    color: rgb(1, 1, 1);
    font-size: 16px;
    font-weight: 100;
    width: 100%px;
    height: 40px;
    border-radius: 8px 8px 0 0;
}


.detail-card>>>.el-descriptions__title {
    font-size: 14px;
    color: #606266;
}

.detail-card>>>.el-descriptions-item__label {
    font-size: var(--label-font-size, 18px);
    color: var(--label-color, #000000);
    background-color: var(--label-color, #fcfcfc);
    width: var(--label-width, 100px);

}

.detail-card>>>.el-descriptions-item__content {
    font-size: var(--label-font-size, 16px);
    color: var(--label-color, #6b6b6b);
    background-color: var(--label-color, #ffffff);
    width: var(--label-width, 400px);
}

/* 自定义样式示例 */
.custom-label {
    --label-font-size: 16px;
    --label-color: #333;
    --label-bg-color: #f0f0f0;
    --label-min-width: 150px;
    --label-width: 25%;
    --label-padding: 8px 20px 8px 10px;
}

.custom-content {
    --content-font-size: 15px;
    --content-color: #444;
    --content-bg-color: #f8f8f8;
    --content-min-width: 250px;
    --content-width: 75%;
    --content-padding: 8px;
}

.el-form-item__label {
    font-size: 14px;
    color: #606266;
}

.el-button {
    font-size: 14px;
    padding: 10px 20px;
}

.el-textarea__inner {
    font-size: 14px;
    color: #303133;
}

.review-standards {
    display: flex;
    flex-direction: column;
}

.standard-item {
    margin-bottom: 50px;
}

.standard-item>>>.el-checkbox__inner {
    border-color: #409EFF;
}

.standard-item.is-checked>>>.el-checkbox__inner {
    background-color: #409EFF;
    border-color: #409EFF;
}

.required-field::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}

.review-standard-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #ebeef5;
}

.review-standard-item:last-child {
    border-bottom: none;
}

.review-comment-input {
    width: 100%;
}

.action-buttons {
    margin-top: 20px;
    text-align: center;
}
</style>